module.exports = __webpack_public_path__ + "img/tc_icom.0094dd64.png";